import styled from 'styled-components';

export const StyledCoinTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 1em;
    
`

export const StyledTableContainer = styled.div`
    max-height: 80vh;
    position: relative;
    overflow-y: auto; 
`;